export const  getDataAndFilter = (arr, type)=>{
    return new Promise((resolve, reject) => {
        try{
            let newArr =  arr.filter(item=> item.levelType == type)
            resolve(newArr)
         }
         catch(err){ (reject([])) }

    })    
}